import classNames from 'classnames';
import { useEffect } from 'react';
import {animated, useSpring} from '@react-spring/web'

import { ToastValue } from 'providers/ToastsProvider';
import Icon, { Icons } from '../icons/Icon';
import { useConfigContext } from 'providers/ConfigProvider';

type ToastProps = {
  className?: string;
  dismiss: () => void;
  toast: ToastValue;
};

function Toast({ className, dismiss, toast }: ToastProps) {
  const config = useConfigContext();

  const [springs, api] = useSpring(() => ({
    from: {opacity: 1, x: 0}
  }));

  const doDismiss = (): void => {
    api.start({
      to: {opacity: 0, x: -1000},
      onRest: () => {dismiss()}
    })
  }

  useEffect(() => {
    if (toast.isAutoDismiss) {
      const dismissInterval = setInterval(() => {
        const dismissAt = toast.createdAt + config.REACT_APP_TOAST_AUTO_DISMISS_MILLIS;
        if (dismissAt < Date.now()) doDismiss();
      }, 500);
      return () => clearTimeout(dismissInterval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toast, config.REACT_APP_TOAST_AUTO_DISMISS_MILLIS]);

  return (
    <animated.div
      data-testid="toast"
      className={classNames(
        'mx-auto max-w-lg rounded-lg bg-gradient-to-r from-blue-800 to-blue-950 p-3 text-blue-200',
        className,
      )}
      style={{...springs}}
    >
      <div className="flex items-center justify-between">
        <div>{toast.text}</div>
        <Icon
          name={Icons.Xmark}
          testId="icon-dismiss"
          onClick={() => doDismiss()}
          className="ml-2 text-xl hover:cursor-pointer"
          role="button"
          title="Dismiss"
        />
      </div>
    </animated.div>
  );
}

export default Toast;
